import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components/macro';

import utils from 'utils';
import selectors from 'state/selectors';

import { ValidationCheckReturnValues } from 'models/response';

import Header from 'components/Modal/Header';
import Modal from 'components/Modal';

export const MessageContainer = styled.div`
  padding: 10px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colorPalette.grey.grey5};
`;

const ValidationCheck = () => {
  const t = utils.intl.useTranslator();
  const modalProps = useSelector(selectors.modal.getModalProps);

  return (
    <>
      <Header title={t('validation_check_title')} subtitle={t('validation_check_subtitle')} />
      <>
        {modalProps.values.map((e: ValidationCheckReturnValues, i: number) => {
          return (
            <MessageContainer key={i}>
              {`${t('message')}: `}
              {e.message}
            </MessageContainer>
          );
        })}
      </>
      <Modal.Footer
        withConfirmButton={false}
        closeButtonText={t('continua')}
      />
    </>
  );
};

export default ValidationCheck;
